/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_DigestInputs */

const en_fw_notify_digest = /** @type {(inputs: Fw_Notify_DigestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily summary`)
};

const id_fw_notify_digest = /** @type {(inputs: Fw_Notify_DigestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan harian`)
};

/**
* | output |
* | --- |
* | "Daily summary" |
*
* @param {Fw_Notify_DigestInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_digest = /** @type {((inputs?: Fw_Notify_DigestInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_DigestInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_digest(inputs)
	return en_fw_notify_digest(inputs)
});